import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './components/Home/Home';
import ProtectedRoute from './components/Auth/ProtectedRoute';

import Login from './components/Auth/Login';
import { PrivacyPolicy } from './components/CompanyPages/PrivacyPolicy';
import TermsCondition from './components/CompanyPages/TermsCondition';
import AudioFileDetail from './components/AudioFiles/AudioFileDetail';
import { AudioPlayerProvider } from './components/AudioFiles/AudioPlayerContext';
import AudioPlayer from './components/AudioFiles/AudioPlayer';
import { SearchGlobalProvider } from './components/Search/SearchGlobalContext';
import MyWatchList from './components/MyWatchList/MyWatchList';
import UserProfile from './components/UserProfile/UserProfile';
import Pages from './components/Pages/Pages';
import LandingPage1 from './components/LandingPages/LandingPage1';
import LandingPage2 from './components/LandingPages/LandingPage2';
import LandingPage3 from './components/LandingPages/LandingPage3';
import MySpace from './components/MySpace/MySpace';
import Search from './components/Search/Search';
import PlansV2 from './components/Plans/PlansV2';
import PaymentSuccess from './components/Plans/PaymentSuccess';
import Dashboard from './components/Dashboard/Dashboard';
import SideNavigation from './components/SideNavigation/SideNavigation';
import { useEffect, useState } from 'react';
import Category from './components/Category/Category';
import DownloadInvoice from './components/Invoice/DownloadInvoice';
import CategoryDetail from './components/Category/CategoryDetail';
import BottomNavigation from './components/BottomNav/BottomNavigation';
import Footer from './components/Footer/Footer';
import WeeklyLogin from './components/Weekly/WeeklyLogin';
import WeeklySuccess from './components/Weekly/WeeklySuccess';
import WeeklyPage from './components/Weekly/WeeklyPage';
import NewWeeklyLogin from './components/NewWeekly/NewWeeklyLogin';
import NewWeeklySuccess from './components/NewWeekly/NewWeeklySuccess';
import NewWeeklyPage from './components/NewWeekly/NewWeeklyPage';

import "toastify-js/src/toastify.css"
import { initPixel } from './utils/pixel';
import { pushEvent, EVENTS } from './utils/dataLayer';
const AppContent = () => {
  // At the very top of App.js or index.js, before React renders
  (function captureLandingInfo() {
    const fullURL = window.location.href; // full URL with query
    const search = window.location.search; // ?utm_source=facebook...

    const urlParams = new URLSearchParams(search);

    // Restore session transferred from login.dastaan.info after payment
    // (localStorage is domain-scoped, so auth data is passed via URL params)
    const authToken = urlParams.get('auth_token');
    if (authToken) {
      localStorage.setItem('dastaan__token', authToken);
      localStorage.setItem('dastaan__user_id', urlParams.get('auth_user_id') || '');
      localStorage.setItem('dastaan__phone', urlParams.get('auth_phone') || '');
      localStorage.setItem('dastaan__name', urlParams.get('auth_name') || '');
      localStorage.setItem('dastaan__user_image', urlParams.get('auth_user_image') || '');
      localStorage.setItem('dastaan__plan_id', urlParams.get('auth_plan_id') || '');
      localStorage.setItem('dastaan__plan_amnt', urlParams.get('auth_plan_amnt') || '');
      const planActive = urlParams.get('auth_plan_active');
      if (planActive) localStorage.setItem('dastaan__plan_active', planActive);
      // Clean auth params from URL immediately so token doesn't linger in history
      const cleanUrl = new URL(window.location.href);
      ['auth_token','auth_user_id','auth_phone','auth_name','auth_user_image','auth_plan_id','auth_plan_amnt','auth_plan_active']
        .forEach(k => cleanUrl.searchParams.delete(k));
      window.history.replaceState({}, '', cleanUrl.toString());
    }

    // ✅ Always overwrite utmData if present in URL
    if (search && search.includes("utm_")) {
      const utmData = {
        utm_source: urlParams.get("utm_source") || "",
        utm_medium: urlParams.get("utm_medium") || "",
        utm_campaign: urlParams.get("utm_campaign") || "",
        click_id: urlParams.get("click_id") || ""
      };
      localStorage.setItem("utmData", JSON.stringify(utmData));
    }

    // ✅ Landing URL: only save once (first time user lands)
    if (!localStorage.getItem("landingURL")) {
      localStorage.setItem("landingURL", fullURL);
    }
  })();

  return (
    <>
      <Routes>
        <Route exact path='/' element={
          <ProtectedRoute><Home /></ProtectedRoute>
        } />
        <Route exact path='/search' element={<ProtectedRoute><Search /></ProtectedRoute>} />
        <Route exact path='/my-space' element={<ProtectedRoute><MySpace /> </ProtectedRoute>} />
        <Route exact path='/download-invoice' element={<ProtectedRoute><DownloadInvoice /></ProtectedRoute>} />
        <Route exact path='/audio-file-detail/:id' element={<ProtectedRoute><AudioFileDetail /></ProtectedRoute>} />
        <Route exact path='/category-details/:id' element={<ProtectedRoute><CategoryDetail /></ProtectedRoute>} />
        {/* <Route path='/tv-shows' element={<TVShowHome />} /> */}
        {/* <Route path='/movies/:id' element={<MovieDetail />} /> */}
        {/* <Route path='/watch/:id' element={ <Watch />} /> */}
        <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route exact path='/categories' element={<ProtectedRoute><Category /></ProtectedRoute>} />
        <Route exact path='/terms-condition' element={<TermsCondition />} />
        <Route exact path='/login' element={<Login />} />
        <Route exact path='/weekly' element={<WeeklyLogin />} />
        <Route exact path='/weekly/success' element={<WeeklySuccess />} />
        <Route exact path='/weekly/payment' element={<WeeklyLogin />} />
        <Route exact path='/weekly/pages/:id' element={<WeeklyPage />} />
        <Route exact path='/new/weekly' element={<NewWeeklyLogin />} />
        <Route exact path='/new/weekly/success' element={<NewWeeklySuccess />} />
        <Route exact path='/new/weekly/payment' element={<NewWeeklyLogin />} />
        <Route exact path='/new/weekly/pages/:id' element={<NewWeeklyPage />} />
        <Route exact path='/profile' element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
        <Route path='/my-watchlist' element={<ProtectedRoute><MyWatchList /></ProtectedRoute>} />
        {/* <Route path='/plans' element={<Plans />} /> */}
        <Route path='/plans' element={<PlansV2 />} />
        <Route path='/payment-success' element={<PaymentSuccess />} />
        <Route path='/dashboard' element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        {/* Public: Terms / Privacy / Refund etc. must be readable before login */}
        <Route path='/pages/:id' element={<Pages />} />
        <Route path='/landingpage1' element={<LandingPage1 />} />
        <Route path='/landingpage2' element={<LandingPage2 />} />
        <Route path='/landingpage3' element={<LandingPage3 />} />
      </Routes>
      <AudioPlayer />
    </>
  );
}
const LayoutWrapper = () => {
  const [dW, setWidth] = useState(window.innerWidth);
  const location = useLocation();
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    initPixel();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // SPA navigation never reloads the page, so GTM only sees the first load.
  // Push a virtual page view on every route change.
  useEffect(() => {
    pushEvent(EVENTS.PAGE_VIEW, {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  const route = location.pathname.split('/')[1];
  // Standalone full-screen pages: no nav bars or footer
  const hideChrome = route === 'weekly' || location.pathname.startsWith('/new/weekly');
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <main style={{ flex: 1, overflowY: 'auto', marginBottom: 75 }}>
        <AppContent />
        {!hideChrome && route !== 'plans' && route !== 'payment-success' && route !== 'audio-file-detail' && (
          <Footer />
        )}
      </main>
      {hideChrome ? null : dW > 768 ? (
        <footer style={{
          position: 'sticky',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 999,
        }}>
          <SideNavigation />
        </footer>
      ) : (
        route !== 'audio-file-detail' && (
          <footer style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 999,
            height: '70px',
            paddingTop: '15px',
            padding: '0px 0px',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            borderTop: '2px solid rgba(190, 179, 179, 0.32)',
            boxShadow: '0 -4px 12px rgba(146, 146, 146, 0.06)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <BottomNavigation />
          </footer>
        )
      )}
    </div>
  );
};
function App() {
  // Added By: Pradyumn Dwivedi; Added on: 29 July 2024; Use: To initialize Facebook Pixel for tracking events
  // Initialize Facebook Pixel
  useEffect(() => {
    // Initialize Facebook Pixel with your Pixel ID
    if (window.fbq) {
      window.fbq('init', '1310440030053294');
      window.fbq('track', 'PageView');
    }
  }, []);

  

  // Added By: Pradyumn Dwivedi; Added on: 29 July 2024; Use: To track a purchase event
  // Track a purchase event
  const handlePurchase = () => {
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: 142.52,
        currency: 'USD'
      });
    }
  };

  return (
    <AudioPlayerProvider>
      <SearchGlobalProvider>
        <Router>
          <LayoutWrapper />
        </Router>
      </SearchGlobalProvider>
    </AudioPlayerProvider>
  );
}
export default App;
